<template> <!-- 批量修改费用 -->
  <el-dialog
    :title="$t('receivablePayable.batchModifyFees')"
    width="800px"
    :top="'10vh'"
    :append-to-body="true"
    :visible.sync="isShow"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
  >
    <el-form
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      size="mini"
      class="error-form"
    >
      <!-- 费用类型-->
      <el-form-item>
        <el-table
          :data="ruleForm.feeCodeList"
          border
          height="300"
        >
          <el-table-column :label="$t('GlobalSetObj.serial')" width="50" type="index" />
          <el-table-column :label="$t('basicData.ExpenseType')">
            <template #header>
              <div>
                <span style="color: #f00;margin-right: 5px;">*</span>
                <span>{{ $t('basicData.ExpenseType') }}</span>
              </div>
            </template>
            <template v-slot="scope">
              <div class="formStyle">
                <el-form-item
                  :prop="'feeCodeList.' + scope.$index + '.feeCode'"
                  :rules="{ required: true, message: $t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }"
                >
                  <el-select
                    v-model="scope.row.feeCode"
                    filterable
                    clearable
                    :placeholder="$t('operationCenter.PleaseSelect')"
                    style="width: 100%;"
                    popper-class="top-select"
                    @change="feeTypeChange"
                  >
                    <el-option
                      v-for="item in feeList"
                      :key="item.id"
                      :label="item.displayName"
                      :value="item.code"
                      :disabled="isOptionDisabled(scope.$index, item.code)"
                    />
                  </el-select>
                </el-form-item>
              </div>
            </template>
          </el-table-column>
          <!--金额-->
          <el-table-column width="120">
            <template #header>
              <div>
                <span style="color: #f00;margin-right: 5px;">*</span>
                <span>{{ $t('receivablePayable.modifiedAmount') }}</span>
              </div>
            </template>
            <template v-slot="scope">
              <el-form-item
                :prop="'feeCodeList.' + scope.$index + '.fee'"
                :rules="{ required: true, suffix: 2, negative: '-?', validator: priceType, trigger: ['blur', 'change'] }"
              >
                <el-input v-model="scope.row.fee" />
              </el-form-item>
            </template>
          </el-table-column>
          <!--备注-->
          <el-table-column
            :label="$t('receivablePayable.remark')"
            width="200"
          >
            <template v-slot="scope">
              <el-form-item :prop="'feeCodeList.' + scope.$index + '.remark'">
                <el-input v-model="scope.row.remark" :placeholder="$t('GlobalSetObj.pleaseInputContent')" />
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column width="60" align="center">
            <template #header>
              <span class="el-icon-plus addStyle" @click="addCost" />
            </template>
            <template v-slot="scope">
              <!--确定删除吗？-->
              <el-popconfirm
                :title="$t('basicData.AreYouSureDelete')"
                @confirm="deleteCost(scope)"
              >
                <span slot="reference" class="el-icon-delete deleteStyle" />
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <!--取 消-->
      <el-button size="small" @click="onClose">{{ $t('basicData.Cancel') }}</el-button>
      <!--确 定-->
      <el-button size="small" type="primary" @click="submitForm">{{ $t('basicData.determine') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { cloneDeep } from 'lodash-es';
import { apiSiteExpenseBatchEditFee } from '@/api/finance/receivables';
import { goFinanceExportPage } from '@/utils/goExportList';

export default {
  props: {
    // 多选
    selectData: {
      type: Array,
      default: () => {
        return [];
      }
    },

    // 搜索条件
    queryForm: {
      type: Object,
      default: () => {
        return {};
      }
    },

    // 后续处理函数
    cb: {
      type: Function,
      default: () => {
        return () => {};
      }
    },

    // 费用类型
    feeTypeOption: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },

  data() {
    const priceType = (rule, value, callback) => {
      const reg = new RegExp('(^' + rule.negative + '[1-9]\\d*(\\.\\d{1,' + rule.suffix + '})?$)|(^' + rule.negative + '0(\\.\\d{1,' + rule.suffix + '})?$)');
      const { required } = rule;
      if (!required) {
        // 非必填
        if (value) {
          if (!reg.test(value)) {
            this.adopt = false;
            return callback(new Error(this.$t('basicData.IncorrectFormatting'))); // 格式不正确
          } else {
            this.adopt = true;
            return callback();
          }
        } else {
          return callback();
        }
      } else {
        if (value) {
          if (!reg.test(value)) {
            this.adopt = false;
            return callback(new Error(this.$t('basicData.IncorrectFormatting'))); // 格式不正确
          } else {
            this.adopt = true;
            return callback();
          }
        } else {
          this.adopt = false;
          return callback(this.$t('basicData.CannotBeEmpty')); // '不能为空'
        }
      }
    };
    return {
      priceType,
      isShow: false,
      key: Date.now(),
      feeList: [],
      ruleForm: {
        feeCodeList: []
      },
      rules: {
        feeCodeList: [
          { required: true, message: this.$t('GlobalSetObj.pleaseChoose'), trigger: 'change' }
        ]
      }
    };
  },

  methods: {
    // 关闭
    onClose() {
      this.isShow = false;
      this.ruleForm.TimeCollection = [];
      this.ruleForm.feeCodeList = [];
    },

    /**
     * 打开
     * @description 打开弹窗
     */
    open() {
      this.isShow = true;
      this.ruleForm.payableType = this.payableType;
      this.feeList = cloneDeep(this.feeTypeOption);
      this.addCost();

      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate();
      });
    },

    // 确定
    submitForm() {
      // 表单校验
      this.$refs.ruleForm.validate(async(valid) => {
        if (valid) {
          const row = this.setData(); // 获取数据
          console.log('保存数据', row);
          if (row) {
            apiSiteExpenseBatchEditFee(row).then(res => {
              if (res.code === 200) {
                goFinanceExportPage().then(() => {
                  this.cb();
                  this.onClose();
                });
              }
            });
          }
        }
      });
    },

    // 数据处理
    setData() {
      try {
        const paramForm = cloneDeep(this.queryForm.params);
        const { businessType } = paramForm;
        const { feeCodeList } = this.ruleForm;

        const ids = this.selectData.length > 0
          ? this.selectData.map(item => item.id)
          : [];
        // 设置业务类型
        feeCodeList.forEach(item => {
          item.businessType = businessType;
        });
        paramForm.ids = ids;
        return {
          condition: paramForm,
          expenseSubList: feeCodeList
        };
      } catch (error) {
        console.error(error);
        return null;
      }
    },

    // 删除费用
    deleteCost(scope) {
      this.ruleForm.feeCodeList.splice(scope.$index, 1);
      this.$forceUpdate();
    },

    // 添加费用
    addCost() {
      this.ruleForm.feeCodeList.push({
        feeCode: '', // 费用类型代码
        fee: '', // 费用
        remark: '' // 备注
      });
    },

    // 选择费用类型
    feeTypeChange() {
      this.$forceUpdate();
    },

    isOptionDisabled(currentIndex, optionValue) {
      // 如果当前行已经选择了这个选项，不禁用（允许取消选择）
      if (this.ruleForm.feeCodeList[currentIndex].feeCode.includes(optionValue)) {
        return false;
      }

      // 检查此选项是否已被其他行选中
      return this.ruleForm.feeCodeList.some((row, index) =>
        index !== currentIndex &&
        row.feeCode &&
        row.feeCode === optionValue
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.error-table  .el-table__body-wrapper {
  overflow: auto !important;
}

.addStyle {
  color: #00A551;
  cursor: pointer;
  font-size: 18px;
}

.deleteStyle {
  color: #F56C6C;
  cursor: pointer;
  font-size: 18px;
}
</style>

